import React from 'react';
import { Box, Typography, Button, styled, alpha } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const HeaderWrapper = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  position: 'relative',
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: -theme.spacing(2),
    left: 0,
    right: 0,
    height: '1px',
    background: 'linear-gradient(90deg, rgba(231, 235, 240, 0.8) 0%, rgba(231, 235, 240, 0) 100%)'
  },
  [theme.breakpoints.up('sm')]: {
    marginBottom: theme.spacing(5)
  }
}));

const BackButton = styled(Button)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textTransform: 'none',
  padding: theme.spacing(0.5, 1),
  marginBottom: theme.spacing(2),
  fontSize: '0.875rem',
  fontWeight: 500,
  letterSpacing: '0.01em',
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.04),
    color: theme.palette.primary.main
  },
  '& .MuiSvgIcon-root': {
    fontSize: '1.25rem',
    transition: 'transform 0.2s ease',
  },
  '&:hover .MuiSvgIcon-root': {
    transform: 'translateX(-2px)'
  }
}));

const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: '1.75rem',
  fontWeight: 700,
  marginBottom: theme.spacing(1),
  letterSpacing: '-0.02em',
  background: 'linear-gradient(135deg, #1A2027 0%, #2A3541 100%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  [theme.breakpoints.up('sm')]: {
    fontSize: '2rem'
  }
}));

const Description = styled(Typography)(({ theme }) => ({
  color: alpha(theme.palette.text.secondary, 0.9),
  fontSize: '0.95rem',
  lineHeight: 1.6,
  maxWidth: '600px'
}));

const PageHeader = ({ title, description, onBack }) => {
  return (
    <HeaderWrapper>
      <BackButton startIcon={<ArrowBackIcon />} onClick={onBack}>
        Back
      </BackButton>
      <Title variant="h1">{title}</Title>
      {description && <Description variant="body1">{description}</Description>}
    </HeaderWrapper>
  );
};

export default PageHeader; 